// @flow
'use strict';

import * as React from 'react';

import type { IProdutoServico } from '../../types';

import ColumnDetalhes from '../../../../common/detalhes_documento/column_detalhes';
import TableDetalhes from '../../../../common/detalhes_documento/table_detalhes';
import ModalDetalhes from './modal_detalhes';

type ProdutoServicoProps = {
  produtoServico : IProdutoServico[],
  modalOpen : bool,
  handleDetalhesClick : () => void,
};

export default function ProdutoServico({ produtoServico, modalOpen, handleDetalhesClick } : ProdutoServicoProps) {
  return (
      <div className="tab-pane active">
        <h3>Dados dos Produtos e Serviços</h3>
        <TableDetalhes data={ produtoServico } noDataMsg="Nenhum item informado na NFC-e">
          <ColumnDetalhes field="item" width="5%">Item</ColumnDetalhes>
          <ColumnDetalhes field="descricao" type="documento">Descrição</ColumnDetalhes>
          <ColumnDetalhes field="ncm" width="10%">NCM</ColumnDetalhes>
          <ColumnDetalhes field="un" width="5%">UN</ColumnDetalhes>
          <ColumnDetalhes field="quantidade" width="10%">Quantidade</ColumnDetalhes>
          <ColumnDetalhes field="valorUnitario" type="moeda" width="10%">Valor Unitário</ColumnDetalhes>
          <ColumnDetalhes field="valorTotal" type="moeda" width="15%">Valor Total do Item</ColumnDetalhes>
          <ColumnDetalhes field="produtoServico" type="botaoDetalhes" buttonClick={ handleDetalhesClick } width="10%"/>
        </TableDetalhes>

        { modalOpen && <ModalDetalhes/> }
      </div>
  );
}